import * as React from 'react';
import { makeStyles, tokens, Button, Text } from '@fluentui/react-components';
import { SlideTextRegular } from '@fluentui/react-icons';
import { useIntl } from 'react-intl';
import { Header } from '../components/Header';
import { SyncStatusBar } from '../components/SyncStatusBar';
import { BrowseView } from './BrowseView';
import { homeMessages } from '../intl/messages';

type ActiveView = 'home' | 'browse';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    padding: tokens.spacingHorizontalM,
  },
  hero: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    marginTop: tokens.spacingVerticalM,
    padding: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground2,
    borderTopWidth: '1px',
    borderRightWidth: '1px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderTopStyle: 'solid',
    borderRightStyle: 'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle: 'solid',
    borderTopColor: tokens.colorNeutralStroke1,
    borderRightColor: tokens.colorNeutralStroke1,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderLeftColor: tokens.colorNeutralStroke1,
  },
  copy: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  eyebrow: {
    color: tokens.colorBrandForeground1,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  title: {
    fontSize: tokens.fontSizeBase600,
    lineHeight: tokens.lineHeightBase600,
    fontWeight: tokens.fontWeightBold,
  },
  description: {
    color: tokens.colorNeutralForeground2,
    maxWidth: '26ch',
  },
  actionButton: {
    justifyContent: 'flex-start',
    minHeight: '56px',
    borderRadius: tokens.borderRadiusLarge,
  },
  hint: {
    color: tokens.colorNeutralForeground2,
  },
});

export function HomeView() {
  const styles = useStyles();
  const intl = useIntl();
  const [activeView, setActiveView] = React.useState<ActiveView>('home');

  if (activeView === 'browse') {
    return <BrowseView onBack={() => setActiveView('home')} />;
  }

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <div className={styles.hero}>
          <div className={styles.copy}>
            <Text size={100} className={styles.eyebrow}>
              {intl.formatMessage(homeMessages.eyebrow)}
            </Text>
            <Text className={styles.title}>
              {intl.formatMessage(homeMessages.heroTitle)}
            </Text>
            <Text className={styles.description}>
              {intl.formatMessage(homeMessages.heroDescription)}
            </Text>
          </div>
          <Button
            className={styles.actionButton}
            icon={<SlideTextRegular />}
            appearance="primary"
            size="large"
            onClick={() => setActiveView('browse')}
          >
            {intl.formatMessage(homeMessages.browseButton)}
          </Button>
          <Text size={200} className={styles.hint}>
            {intl.formatMessage(homeMessages.hint)}
          </Text>
        </div>
      </div>
      <SyncStatusBar />
    </div>
  );
}
